import client from "./client";

export const listSalaryHolds = async () => (await client.get("/payroll/holds")).data;
export const scanSalaryHolds = async () => (await client.post("/payroll/holds/scan")).data;
export const releaseSalaryHold = async (id) => (await client.post(`/payroll/holds/${id}/release`)).data;
export const mySalaryHold = async () => (await client.get("/payroll/holds/me")).data;
